"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _loaderModule = _interopRequireDefault(require("./loader.module.scss"));
var Loader = function Loader(_ref) {
  var _classNames;
  var testId = _ref['data-testid'],
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": testId,
    className: (0, _classnames.default)(_loaderModule.default['loader'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _loaderModule.default['loader--small'], small), (0, _defineProperty2.default)(_classNames, _loaderModule.default["loader--".concat(variant)], variant), _classNames))
  });
};
exports.Loader = Loader;